import { AfterViewInit, Component, ViewChild } from '@angular/core';
import { MatTableDataSource, MatTable } from '@angular/material/table';
import { ListComponent } from 'src/app/common/component/list.component';
import { MatSort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';

@Component({
	selector: 'app-settlement-term-list',
	templateUrl: './settlement-term-list.component.html',
	styleUrls: ['./settlement-term-list.component.css'],
})
export class SettlementTermListComponent extends ListComponent implements AfterViewInit {
	@ViewChild('dataTable') table: MatTable<any>;
	@ViewChild(MatPaginator) paginator: MatPaginator;
	@ViewChild(MatSort) sort: MatSort;

	protected apiUrl = 'settlements/settlementBonusTerm';
	data: Array<object>;
	showTable = true;
	matData = new MatTableDataSource<any>();
	protected filterValue = '';
	filters;
	displayedColumns: string[] = ['driver', 'name', 'month', 'value', 'comment', 'isSettled', 'settlementsBonusId'];

	parameters = {
		drivers: [],
		users: [],
		settlementBonusNameIds: [],
		isSettled: [
			{ id: 0, name: 'Nie' },
			{ id: 1, name: 'Tak' },
		],
		settlementKinds: [
			{ id: 1, name: 'Dodatek' },
			{ id: 2, name: 'Potrącenie' },
		],
	};
	itemsBeforeDataLoad = 4;
	sum = 0;
	sumIsSettled = 0;
	sumIsNotSettled = 0;

	protected loadBefore(): void {
		this.api.get('/drivers/', (result) => {
			this.parameters.drivers = result.data;
			this.loadData();
		});
		this.api.get('/settlements/settlementBonusName/', (result) => {
			this.parameters.settlementBonusNameIds = result.data;
			this.loadData();
		});
		this.api.get('/users/', (result) => {
			this.parameters.users = result.data;
			this.loadData();
		});
	}

	refreshFilter() {
		if (this.filterValue.length < 3 && this.filterValue.length > 0) {
			return;
		}
		this.matData.filter = this.filterValue.trim().toLowerCase();
	}

	ngAfterViewInit() {
		this.matData.sort = this.sort;
		this.matData.paginator = this.paginator;
	}

	convertData(result) {
		this.sum = 0;
		this.sumIsSettled = 0;
		this.sumIsNotSettled = 0;
		result.forEach((element) => {
			this.sum += parseFloat(element.value);
			if (element.isSettled == '1') {
				this.sumIsSettled += parseFloat(element.value);
			} else {
				this.sumIsNotSettled += parseFloat(element.value);
			}
			element.isSettled = element.isSettled == '1' ? 'Tak' : 'Nie';
		});
		this.matData.data = result;
		return this.matData.data;
	}

	filtersSelected(data) {
		this.filters = data;
		if (!this.filters.date_from) {
			this.filters.date_from = this.date.daysAdd(-15);
		}
		if (!this.filters.date_to) {
			this.filters.date_to = this.date.daysAdd(+15);
		}
		this.loadData();
	}
}
